/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
type Development_development$ref = any;
type Layout_pageWithData$ref = any;
type Layout_root$ref = any;
type PageMeta_root$ref = any;
export type developmentQueryVariables = {|
  slug: string,
  uid: string,
  lang: string,
|};
export type developmentQueryResponse = {|
  +developmentProductBySlug: ?{|
    +title: ?string,
    +$fragmentRefs: Development_development$ref,
  |},
  +cms: {|
    +pageWithData: ?{|
      +$fragmentRefs: Layout_pageWithData$ref
    |}
  |},
  +$fragmentRefs: Layout_root$ref & PageMeta_root$ref,
|};
export type developmentQuery = {|
  variables: developmentQueryVariables,
  response: developmentQueryResponse,
|};
*/


/*
query developmentQuery(
  $slug: String!
  $uid: String!
  $lang: String!
) {
  ...Layout_root_3iqx2P
  ...PageMeta_root
  developmentProductBySlug(slug: $slug) {
    ...Development_development
    title
    id
  }
  cms {
    pageWithData(uid: $uid, lang: $lang) {
      ...Layout_pageWithData
    }
  }
}

fragment Breadcrumbs_hierarchy on CMSPage {
  template
  link_title
  custom_path
  _meta {
    uid
  }
}

fragment DevelopmentActionBar_development on DevelopmentProduct {
  ...DevelopmentEnquiry_development
  id
  registrationType
  currentUserRegistrationForm {
    id
    completed
  }
}

fragment DevelopmentActionCard_development on DevelopmentProduct {
  ...DevelopmentEnquiry_development
  id
  currentUserRegistrationForm {
    id
    completed
  }
  registrationType
  products {
    ...lotPrice_product
    ...lotPricePerMeterSquared_product
    salePrice
    id
  }
}

fragment DevelopmentDescription_development on DevelopmentProduct {
  description
}

fragment DevelopmentEnquiry_development on DevelopmentProduct {
  id
  products {
    id
    lotReference
    salePrice
    currency
    status
    property {
      numberOfRooms
      floorOfFlat
      id
    }
  }
}

fragment DevelopmentHeader_development on DevelopmentProduct {
  title
  deliveryDate
  products {
    ...lotPrice_product
    ...lotPricePerMeterSquared_product
    salePrice
    property {
      numberOfRooms
      locality
      postcode
      id
    }
    id
  }
}

fragment DevelopmentLocation_development on DevelopmentProduct {
  products {
    property {
      lat
      lng
      locality
      postcode
      route
      streetNumber
      id
    }
    id
  }
}

fragment DevelopmentLots_development on DevelopmentProduct {
  ...DevelopmentProductSelectionDialog_development
  id
  mappingImage {
    ...MappingImage_image
    id
  }
  products {
    ...DevelopmentProductDetails_product
    ...MappingImage_products
    id
    lotReference
    salePrice
    displayStatus
    hidePriceOnPortals
    property {
      floorOfFlat
      numberOfRooms
      numberOfBedrooms
      grossFloorSurface
      balconySurface
      gardenSurface
      terraceSurface
      basementSurface
      weightedFloorSurface
      livingSurface
      usableSurface
      id
    }
  }
}

fragment DevelopmentOrganisation_organisation on Organisation {
  name
  formattedAddress
  primaryImage {
    url
    id
  }
}

fragment DevelopmentProductDetails_product on Product {
  salePrice
  lotReference
  displayStatus
  hidePriceOnPortals
  property {
    livingSurface
    usableSurface
    grossFloorSurface
    gardenSurface
    terraceSurface
    balconySurface
    landSurface
    basementSurface
    weightedFloorSurface
    buildingVolume
    numberOfRooms
    numberOfBedrooms
    numberOfBathrooms
    numberOfToilets
    floorOfFlat
    constructionYear
    renovationYear
    numberOfIndoorParkings
    numberOfOutdoorParkings
    id
  }
}

fragment DevelopmentProductSelectionDialog_development on DevelopmentProduct {
  ...DevelopmentEnquiry_development
  id
  mappingImage {
    ...MappingImage_image
    id
  }
  currentUserRegistrationForm {
    id
    product {
      id
    }
  }
  registrationType
  products {
    ...DevelopmentProductDetails_product
    ...MappingImage_products
    id
    lotReference
    status
  }
}

fragment DevelopmentProjectConsortium_development on DevelopmentProduct {
  broker {
    organisation {
      ...DevelopmentOrganisation_organisation
      id
    }
    id
  }
  developer {
    ...DevelopmentOrganisation_organisation
    id
  }
  architect {
    ...DevelopmentOrganisation_organisation
    id
  }
  generalContractor {
    ...DevelopmentOrganisation_organisation
    id
  }
}

fragment Development_development on DevelopmentProduct {
  ...DevelopmentHeader_development
  ...DevelopmentProjectConsortium_development
  ...DevelopmentDescription_development
  ...DevelopmentLocation_development
  ...DevelopmentActionCard_development
  ...DevelopmentActionBar_development
  ...DevelopmentLots_development
  developmentImages {
    title
    displayOnListing
    crop
    backgroundColor
    image {
      url
      id
    }
    id
  }
}

fragment Layout_pageWithData on CMSPageWithData {
  hierarchy {
    ...Breadcrumbs_hierarchy
  }
  page {
    template
    canonical_url {
      __typename
      ... on CMS_ExternalLink {
        url
      }
      ... on CMSPage {
        _meta {
          uid
          lang
        }
      }
    }
    meta_robots
    show_phone
    _meta {
      id
      lang
      alternateLanguages {
        uid
        lang
        id
      }
    }
  }
}

fragment Layout_root_3iqx2P on Query {
  cms {
    navigation(uid: "main", lang: $lang) {
      nav_logo_link {
        __typename
        ... on CMSPage {
          template
          _meta {
            uid
            lang
          }
        }
      }
      phone_number
      body {
        __typename
        ... on CMSNavigationBodyNavigation_item {
          primary {
            label
            pathname
            nav_link {
              __typename
              ... on CMSPage {
                template
                _meta {
                  id
                  uid
                  lang
                }
              }
            }
          }
          fields {
            label
            pathname
            sub_nav_link {
              __typename
              ... on CMSPage {
                template
                _meta {
                  uid
                  lang
                }
              }
            }
          }
        }
      }
    }
    footerNavigation: navigation(uid: "footer", lang: $lang) {
      phone_number
    }
  }
}

fragment MappingImage_image on Image {
  id
  url
}

fragment MappingImage_products on Product {
  id
  status
  mapping {
    svgPath
  }
}

fragment PageMeta_root on Query {
  cms {
    pageWithData(uid: $uid, lang: $lang) {
      page {
        title
        description
      }
    }
  }
}

fragment lotPricePerMeterSquared_product on Product {
  currency
  salePrice
  property {
    livingSurface
    builtSurface
    weightedFloorSurface
    usableSurface
    id
  }
}

fragment lotPrice_product on Product {
  currency
  offerType
  rentNet
  salePrice
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lang"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uid"
},
v3 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "kind": "Variable",
  "name": "lang",
  "variableName": "lang"
},
v6 = [
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "uid",
    "variableName": "uid"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "template",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uid",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lang",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "CMSMeta",
  "kind": "LinkedField",
  "name": "_meta",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v12 = [
  (v7/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v8/*: any*/),
      (v11/*: any*/)
    ],
    "type": "CMSPage",
    "abstractKey": null
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone_number",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pathname",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v19 = [
  (v18/*: any*/),
  (v16/*: any*/)
],
v20 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "formattedAddress",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "primaryImage",
    "plural": false,
    "selections": (v19/*: any*/),
    "storageKey": null
  },
  (v16/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "developmentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DevelopmentProduct",
        "kind": "LinkedField",
        "name": "developmentProductBySlug",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Development_development"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CMS",
        "kind": "LinkedField",
        "name": "cms",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "CMSPageWithData",
            "kind": "LinkedField",
            "name": "pageWithData",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Layout_pageWithData"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": [
          (v5/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "Layout_root"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "PageMeta_root"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "developmentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CMS",
        "kind": "LinkedField",
        "name": "cms",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v5/*: any*/),
              {
                "kind": "Literal",
                "name": "uid",
                "value": "main"
              }
            ],
            "concreteType": "CMSNavigation",
            "kind": "LinkedField",
            "name": "navigation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "nav_logo_link",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "body",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CMSNavigationBodyNavigation_itemPrimary",
                        "kind": "LinkedField",
                        "name": "primary",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "nav_link",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CMSMeta",
                                    "kind": "LinkedField",
                                    "name": "_meta",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "CMSPage",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CMSNavigationBodyNavigation_itemFields",
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": true,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "sub_nav_link",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "CMSNavigationBodyNavigation_item",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "footerNavigation",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Literal",
                "name": "uid",
                "value": "footer"
              }
            ],
            "concreteType": "CMSNavigation",
            "kind": "LinkedField",
            "name": "navigation",
            "plural": false,
            "selections": [
              (v13/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "CMSPageWithData",
            "kind": "LinkedField",
            "name": "pageWithData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CMSPage",
                "kind": "LinkedField",
                "name": "page",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v17/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "canonical_url",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*: any*/)
                        ],
                        "type": "CMS_ExternalLink",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v11/*: any*/)
                        ],
                        "type": "CMSPage",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meta_robots",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "show_phone",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CMSMeta",
                    "kind": "LinkedField",
                    "name": "_meta",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CMSRelatedDocument",
                        "kind": "LinkedField",
                        "name": "alternateLanguages",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CMSPage",
                "kind": "LinkedField",
                "name": "hierarchy",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "link_title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "custom_path",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CMSMeta",
                    "kind": "LinkedField",
                    "name": "_meta",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DevelopmentProduct",
        "kind": "LinkedField",
        "name": "developmentProductBySlug",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deliveryDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Product",
            "kind": "LinkedField",
            "name": "products",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "offerType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rentNet",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salePrice",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Property",
                "kind": "LinkedField",
                "name": "property",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "livingSurface",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "builtSurface",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weightedFloorSurface",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "usableSurface",
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "numberOfRooms",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "locality",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "postcode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lat",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lng",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "route",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "streetNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "floorOfFlat",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "grossFloorSurface",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "gardenSurface",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "terraceSurface",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "balconySurface",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "landSurface",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "basementSurface",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buildingVolume",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "numberOfBedrooms",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "numberOfBathrooms",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "numberOfToilets",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "constructionYear",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "renovationYear",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "numberOfIndoorParkings",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "numberOfOutdoorParkings",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lotReference",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hidePriceOnPortals",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DevelopmentMapping",
                "kind": "LinkedField",
                "name": "mapping",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "svgPath",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "broker",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Organisation",
                "kind": "LinkedField",
                "name": "organisation",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Organisation",
            "kind": "LinkedField",
            "name": "developer",
            "plural": false,
            "selections": (v20/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Organisation",
            "kind": "LinkedField",
            "name": "architect",
            "plural": false,
            "selections": (v20/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Organisation",
            "kind": "LinkedField",
            "name": "generalContractor",
            "plural": false,
            "selections": (v20/*: any*/),
            "storageKey": null
          },
          (v17/*: any*/),
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DevelopmentRegistrationForm",
            "kind": "LinkedField",
            "name": "currentUserRegistrationForm",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "completed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "registrationType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "mappingImage",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DevelopmentImage",
            "kind": "LinkedField",
            "name": "developmentImages",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayOnListing",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "crop",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "backgroundColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "image",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f6cd5811f3680ebadc59a2f5560f0976",
    "id": null,
    "metadata": {},
    "name": "developmentQuery",
    "operationKind": "query",
    "text": "query developmentQuery(\n  $slug: String!\n  $uid: String!\n  $lang: String!\n) {\n  ...Layout_root_3iqx2P\n  ...PageMeta_root\n  developmentProductBySlug(slug: $slug) {\n    ...Development_development\n    title\n    id\n  }\n  cms {\n    pageWithData(uid: $uid, lang: $lang) {\n      ...Layout_pageWithData\n    }\n  }\n}\n\nfragment Breadcrumbs_hierarchy on CMSPage {\n  template\n  link_title\n  custom_path\n  _meta {\n    uid\n  }\n}\n\nfragment DevelopmentActionBar_development on DevelopmentProduct {\n  ...DevelopmentEnquiry_development\n  id\n  registrationType\n  currentUserRegistrationForm {\n    id\n    completed\n  }\n}\n\nfragment DevelopmentActionCard_development on DevelopmentProduct {\n  ...DevelopmentEnquiry_development\n  id\n  currentUserRegistrationForm {\n    id\n    completed\n  }\n  registrationType\n  products {\n    ...lotPrice_product\n    ...lotPricePerMeterSquared_product\n    salePrice\n    id\n  }\n}\n\nfragment DevelopmentDescription_development on DevelopmentProduct {\n  description\n}\n\nfragment DevelopmentEnquiry_development on DevelopmentProduct {\n  id\n  products {\n    id\n    lotReference\n    salePrice\n    currency\n    status\n    property {\n      numberOfRooms\n      floorOfFlat\n      id\n    }\n  }\n}\n\nfragment DevelopmentHeader_development on DevelopmentProduct {\n  title\n  deliveryDate\n  products {\n    ...lotPrice_product\n    ...lotPricePerMeterSquared_product\n    salePrice\n    property {\n      numberOfRooms\n      locality\n      postcode\n      id\n    }\n    id\n  }\n}\n\nfragment DevelopmentLocation_development on DevelopmentProduct {\n  products {\n    property {\n      lat\n      lng\n      locality\n      postcode\n      route\n      streetNumber\n      id\n    }\n    id\n  }\n}\n\nfragment DevelopmentLots_development on DevelopmentProduct {\n  ...DevelopmentProductSelectionDialog_development\n  id\n  mappingImage {\n    ...MappingImage_image\n    id\n  }\n  products {\n    ...DevelopmentProductDetails_product\n    ...MappingImage_products\n    id\n    lotReference\n    salePrice\n    displayStatus\n    hidePriceOnPortals\n    property {\n      floorOfFlat\n      numberOfRooms\n      numberOfBedrooms\n      grossFloorSurface\n      balconySurface\n      gardenSurface\n      terraceSurface\n      basementSurface\n      weightedFloorSurface\n      livingSurface\n      usableSurface\n      id\n    }\n  }\n}\n\nfragment DevelopmentOrganisation_organisation on Organisation {\n  name\n  formattedAddress\n  primaryImage {\n    url\n    id\n  }\n}\n\nfragment DevelopmentProductDetails_product on Product {\n  salePrice\n  lotReference\n  displayStatus\n  hidePriceOnPortals\n  property {\n    livingSurface\n    usableSurface\n    grossFloorSurface\n    gardenSurface\n    terraceSurface\n    balconySurface\n    landSurface\n    basementSurface\n    weightedFloorSurface\n    buildingVolume\n    numberOfRooms\n    numberOfBedrooms\n    numberOfBathrooms\n    numberOfToilets\n    floorOfFlat\n    constructionYear\n    renovationYear\n    numberOfIndoorParkings\n    numberOfOutdoorParkings\n    id\n  }\n}\n\nfragment DevelopmentProductSelectionDialog_development on DevelopmentProduct {\n  ...DevelopmentEnquiry_development\n  id\n  mappingImage {\n    ...MappingImage_image\n    id\n  }\n  currentUserRegistrationForm {\n    id\n    product {\n      id\n    }\n  }\n  registrationType\n  products {\n    ...DevelopmentProductDetails_product\n    ...MappingImage_products\n    id\n    lotReference\n    status\n  }\n}\n\nfragment DevelopmentProjectConsortium_development on DevelopmentProduct {\n  broker {\n    organisation {\n      ...DevelopmentOrganisation_organisation\n      id\n    }\n    id\n  }\n  developer {\n    ...DevelopmentOrganisation_organisation\n    id\n  }\n  architect {\n    ...DevelopmentOrganisation_organisation\n    id\n  }\n  generalContractor {\n    ...DevelopmentOrganisation_organisation\n    id\n  }\n}\n\nfragment Development_development on DevelopmentProduct {\n  ...DevelopmentHeader_development\n  ...DevelopmentProjectConsortium_development\n  ...DevelopmentDescription_development\n  ...DevelopmentLocation_development\n  ...DevelopmentActionCard_development\n  ...DevelopmentActionBar_development\n  ...DevelopmentLots_development\n  developmentImages {\n    title\n    displayOnListing\n    crop\n    backgroundColor\n    image {\n      url\n      id\n    }\n    id\n  }\n}\n\nfragment Layout_pageWithData on CMSPageWithData {\n  hierarchy {\n    ...Breadcrumbs_hierarchy\n  }\n  page {\n    template\n    canonical_url {\n      __typename\n      ... on CMS_ExternalLink {\n        url\n      }\n      ... on CMSPage {\n        _meta {\n          uid\n          lang\n        }\n      }\n    }\n    meta_robots\n    show_phone\n    _meta {\n      id\n      lang\n      alternateLanguages {\n        uid\n        lang\n        id\n      }\n    }\n  }\n}\n\nfragment Layout_root_3iqx2P on Query {\n  cms {\n    navigation(uid: \"main\", lang: $lang) {\n      nav_logo_link {\n        __typename\n        ... on CMSPage {\n          template\n          _meta {\n            uid\n            lang\n          }\n        }\n      }\n      phone_number\n      body {\n        __typename\n        ... on CMSNavigationBodyNavigation_item {\n          primary {\n            label\n            pathname\n            nav_link {\n              __typename\n              ... on CMSPage {\n                template\n                _meta {\n                  id\n                  uid\n                  lang\n                }\n              }\n            }\n          }\n          fields {\n            label\n            pathname\n            sub_nav_link {\n              __typename\n              ... on CMSPage {\n                template\n                _meta {\n                  uid\n                  lang\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    footerNavigation: navigation(uid: \"footer\", lang: $lang) {\n      phone_number\n    }\n  }\n}\n\nfragment MappingImage_image on Image {\n  id\n  url\n}\n\nfragment MappingImage_products on Product {\n  id\n  status\n  mapping {\n    svgPath\n  }\n}\n\nfragment PageMeta_root on Query {\n  cms {\n    pageWithData(uid: $uid, lang: $lang) {\n      page {\n        title\n        description\n      }\n    }\n  }\n}\n\nfragment lotPricePerMeterSquared_product on Product {\n  currency\n  salePrice\n  property {\n    livingSurface\n    builtSurface\n    weightedFloorSurface\n    usableSurface\n    id\n  }\n}\n\nfragment lotPrice_product on Product {\n  currency\n  offerType\n  rentNet\n  salePrice\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ee3034c5f0d7dbd748d65c3cfe40f766';

export default node;
